import React, { Component } from "react";
import cx from "classnames";
import FormFields from "./FormFields";
import { evalCondition } from "../utils/conditions";
import every from "lodash/every";
import { hasRequiredData, extractFields, isUpdate } from "../utils";
import "./tabs.scss";

const hasRegistration = !!extractFields(window.__DATA__.fields).find((f) => f.name === "registered");

export default class TabButton extends React.PureComponent {
  render() {
    const { text, label, disabled, onClick, strings = {}, isUpdate, ...props } = this.props;
    const { update = "Mettre à jour" } = strings;
    // Text or label, legacy...
    const buttonLabel = (isUpdate ? update : label) || label || text;
    return (
      <div className="af-container" {...props}>
        <button type="submit" className="af-form-button" onClick={onClick} disabled={disabled}>
          {buttonLabel || "Submit"}
        </button>
      </div>
    );
  }
}

class Header extends Component {
  isDisabled = (index) => {
    const { tabs } = this.props;
    for (let i = 0; i < index; i++) {
      if (!tabs[i].isFinished) {
        return true;
      }
    }
    return false;
  };

  render() {
    const { tabs, activeIndex, onSelect } = this.props;

    return (
      <div className="af-tabs__header">
        {tabs.map((tab, index) => {
          const disabled = !tab.alwaysOpen && this.isDisabled(index);
          return (
            <div
              key={index}
              className={cx("af-tab", index === activeIndex && "af-tab--active", disabled && "af-tab--disabled")}
              onClick={() => !disabled && onSelect(index)}
            >
              {tab.label}
            </div>
          );
        })}
      </div>
    );
  }
}

class Tab extends Component {
  state = {
    forceDisabled: false,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // temporaryLock = () => {
  //   setTimeout(() => {
  //     this.setState({ forceDisabled: true });
  //   }, 100);
  //   setTimeout(() => {
  //     if (this._isMounted) {
  //       this.setState({ forceDisabled: false });
  //     }
  //   }, 1000); // Debounce clicks for 1 second
  // };

  handleClick = (e) => {
    const { isLast, onSelect, index } = this.props;
    if (isLast || this.isUpdate()) {
      // Force disable to debounce clicks
      // this.temporaryLock();
      return; // Let normal submit...
    }
    e.preventDefault();
    e.stopPropagation();

    onSelect(index + 1); // Goto next
  };

  render() {
    const { active, style, disableIfUpdate, ...props } = this.props;
    return (
      <div
        className={`af-tabs__content ${active ? "af-tabs__content--active" : ""} ${
          disableIfUpdate && window.__DATA__.isUpdate ? "af-tabs__content--disabled" : ""
        }`}
        style={style}
      >
        <FormFields {...props} />
        {this.renderButton()}
      </div>
    );
  }

  isUpdate() {
    const { allFinished } = this.props;
    // Only consider it an update if not finished
    return isUpdate() && allFinished;
  }

  getButtonLabel() {
    const { isLast, strings = {} } = this.props;
    const { update = "Mettre à jour", validate = "Valider mon inscription", next = "Onglet suivant" } = strings;
    if (this.isUpdate()) return update;
    if (isLast) return validate;
    return next;
  }

  renderButton() {
    const { isFinished, isLast, strings = {}, data } = this.props;
    const { forceDisabled } = this.state;
    if (hasRegistration && data.registered !== "YES") return false; // Hardcoded, evil

    const { completeAllFields = "Veuillez compléter tous les champs pour continuer" } = strings;
    return (
      <React.Fragment>
        {!isFinished && <div className="af-message af-message--alert">{completeAllFields}</div>}
        <TabButton
          label={this.getButtonLabel()}
          disabled={!isFinished || (isFinished && forceDisabled)}
          onClick={isFinished ? this.handleClick : undefined}
          strings={strings}
          isUpdate={this.isUpdate()}
        />
      </React.Fragment>
    );
  }
}

function hasFields(tab, data) {
  const { fields } = tab;
  return !!fields.find((f) => evalCondition(f.condition, data));
}

class Tabs extends Component {
  constructor(props) {
    super(props);
    const { activeTab } = props;
    this.state = {
      activeIndex: activeTab || 0,
    };
  }

  handleTabChange = (activeIndex) =>
    this.setState({ activeIndex }, () => {
      window.scroll(0, 0);
    });

  componentWillReceiveProps = (nextProps) => {
    const { activeTab } = this.props;
    if (activeTab !== nextProps.activeTab) {
      this.setState({ activeIndex: nextProps.activeTab });
    }
  };

  render() {
    const { tabs, autoHideEmptyTabs, data, errors, onChange, strings } = this.props;
    const { activeIndex } = this.state;

    const currentTabs = tabs
      .filter((tab) => evalCondition(tab.condition, data))
      .filter((tab) => !autoHideEmptyTabs || hasFields(tab, data))
      .map((tab, index) => ({
        ...tab,
        isFinished: hasRequiredData(tabs[index].fields, data),
      }));
    const allFinished = every(currentTabs, (tab) => tab.isFinished);
    console.log("allFinished", allFinished);

    return (
      <div className="af-tabs">
        <Header activeIndex={activeIndex} tabs={currentTabs} data={data} onSelect={this.handleTabChange} />
        {currentTabs.map((col, index) => {
          return (
            <Tab
              key={index}
              strings={strings}
              onSelect={this.handleTabChange}
              index={index}
              active={index === activeIndex}
              isLast={index === currentTabs.length - 1}
              {...col}
              allFinished={allFinished}
              data={data}
              errors={errors}
              onChange={onChange}
            />
          );
        })}
      </div>
    );
  }
}

export { Tabs, Tab };
